import React, {memo} from 'react';

import {secondsToHours} from '../../../../../util/date';
import {
  LimitedResourceType,
  UsageCardLimitedResource,
} from './UsageCardLimitedResource';

type TrackedHourUsageProps = {
  loading: boolean;
  trackedHourUsageSeconds?: number;
  trackedHourLimitSeconds?: number;
  showsUnlimitedText?: boolean;
  resourceType?: LimitedResourceType;
};

const TrackedHourUsageCardComp = ({
  loading,
  trackedHourUsageSeconds,
  trackedHourLimitSeconds,
  showsUnlimitedText = false,
  resourceType = LimitedResourceType.TRACKED_HOUR,
}: TrackedHourUsageProps) => {
  // use UsageCardLimitedResource for tracked hour because
  // users on self-serve plans have limited tracked hour in privilege
  return (
    <UsageCardLimitedResource
      resourceType={resourceType}
      loading={loading}
      usage={
        trackedHourUsageSeconds !== undefined
          ? Math.floor(secondsToHours(trackedHourUsageSeconds))
          : 0
      }
      limit={
        trackedHourLimitSeconds !== undefined
          ? secondsToHours(trackedHourLimitSeconds)
          : undefined
      }
      showsUnlimitedText={showsUnlimitedText}
    />
  );
};

export const TrackedHourUsageCard = memo(TrackedHourUsageCardComp);
